import { Button } from 'antd'

import { pick } from '@eastcoal/common/utils/object'

import { AuctionOperationPageStatus } from '../../../enums/AuctionOperationPageStatus'
import { useAuctionListStore } from '../../../Store/hooks/useStore'

import { BidRecordListButtonProps } from './interface'

export const BidRecordListButton = ({ record }: BidRecordListButtonProps) => {
  const { setCurrentAuction, toggleBidRecordListModalVisible } =
    useAuctionListStore(state =>
      pick(state, ['setCurrentAuction', 'toggleBidRecordListModalVisible'])
    )

  const handleClick = () => {
    setCurrentAuction(record)
    toggleBidRecordListModalVisible(true)
  }

  const { status = AuctionOperationPageStatus.WAIT_START } = record

  return Number(status) > AuctionOperationPageStatus.BIDDING ? (
    <Button type='link' onClick={handleClick}>
      出价记录
    </Button>
  ) : null
}
